import config from "../config";

const getNameSpaceFromUrl = () =>
  config.developmentMode ? "xyndata" : /:\/\/([^/]+)/.exec(window.location.href)[1].split(".")[0];

export default getNameSpaceFromUrl;
